import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Button from "@mui/material/Button";
import Chip from '@mui/material/Chip';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import * as util from "../../utils/util";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));




const HealthResultItem = (props: any) => {
  type Anchor = 'bottom'
  const [state, setState] = React.useState({
    bottom: false,
  });
  const [categoryB, setCategoryB] = React.useState<string[]>([]);

  useEffect(() => {

    const resultByCategoryB = props.resultItemData.reduce((acc: any, curr: any) => {
      const { categoryB } = curr;
      if (acc[categoryB]) acc[categoryB].push(curr);
      else acc[categoryB] = [curr];
      return acc;
    }, {});
    setCategoryB(Object.keys(resultByCategoryB));

  }, []);

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  return (
    <React.Fragment>
      {(['bottom'] as const).map((anchor) => (
        <React.Fragment key={anchor}>

          {props.componentName === '검진결과보기' ? (
            <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#0d6703', p: 1 }} onClick={handleClickOpen} >
              <Typography sx={{ fontWeight: 700, color: '#fff' }}>검진결과보기  <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#fff' }} /></Typography>
            </Box>
          ) : (
            <Button onClick={handleClickOpen} sx={{ p: 0, minWidth: 0, '&:hover': { bgcolor: '#fff' } }}>
              <Stack alignItems={'center'} justifyContent={'center'} spacing={1} sx={resultIconBtn}>
                <Img alt="" src={props.src} sx={{ width: props.width }} />
                <Typography dangerouslySetInnerHTML={{ __html: props.componentName }}></Typography>
              </Stack>
            </Button>
          )}

          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}

          >
            <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold' }} id="customized-dialog-title">
              {props.componentName.replaceAll('<br />', ' / ',).replaceAll("<span style='letter-spacing:0'>", '').replaceAll('</span>', '')}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers sx={{ width: 900 }}>
              <Box
                sx={{ bgcolor: '#f9f9f9' }}
                role="presentation"
                onKeyDown={toggleDrawer(props.anchor, false)}
              >
                {/* <Stack direction={'row'} justifyContent={'center'} mb={1} p={2} sx={{ position: 'fixed', width: '100%', bgcolor: '#fff', zIndex: 1, boxSizing: 'border-box', borderBottom: '1px solid #ccc' }}>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', }}></Typography>

                  <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', mr: 1, color: '#777' }} onClick={toggleDrawer(props.anchor, false)}>X</Typography>
                </Stack> */}

                {props.componentName === '종합소견' ? (
                  <Box sx={{ p: 2, pt: 10, bgcolor: '#f9f9f9' }}>
                    {props.resultItemData && props.resultItemData.map((item: any) => (
                      <Card sx={resultBox}>
                        <Typography sx={resultTotal}>{item}</Typography>
                      </Card>
                    ))}
                  </Box>
                ) : (
                  <React.Fragment>
                    <Box sx={{ bgcolor: '#fff', p: 1, textAlign: 'right', pr: 2 }}>
                      <Typography sx={{ fontSize: 14, }}>검진항목 <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 700 }}>{props.resultItemData.length}</Typography>개</Typography>
                    </Box>

                    {categoryB.length <= 0 ? (
                      <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ my: 10, }}>
                        <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
                        <Typography sx={{ fontSize: 16, color: '#888', pb: 10 }} >
                          {props.componentName.replaceAll('<br />', '/').replaceAll("<span style='letter-spacing:0'>", '').replaceAll("</span>", '')} 정보가 없습니다.
                        </Typography>
                      </Stack>
                    ) : (
                      categoryB && categoryB.map((itemKey: any) => (
                        <Box sx={{ p: 2, bgcolor: '#f9f9f9' }}>
                          <Typography sx={mainTitle}></Typography>
                          <Divider sx={titleDivider} >{itemKey}</Divider>

                          {props.resultItemData.filter((v: any) => v.categoryB === itemKey).map((item: any, index: any) => (
                            item.resultCase === 'A' ? (
                              <Card sx={resultBox}>
                                <Typography sx={resultTitle}>{item.inspection}</Typography>
                                <Divider orientation="vertical" flexItem sx={divider} />
                                <Typography sx={result}>{util.strNull(item.result).trim() !== '' ? item.result : '-'} <Typography component={'span'} sx={resultUnit}>{item.unit}</Typography></Typography>
                              </Card>
                            ) : (
                              <Card sx={resultChartBox}>

                                {
                                  item.inspection === '비만도(BMI)'
                                    ? <Stack direction={'row'} alignItems={'center'}>
                                      <Typography sx={resultTitle}>{item.inspection}</Typography>
                                      <Box sx={{ ml: 'auto' }}>
                                        <Chip
                                          label={
                                            item.result < '18.5' ? '저체중' : item.result >= '18.5' && item.result < '23.0' ? '정상' : item.result >= '23.0' && item.result < '25.0' ? '과체중' : item.result >= '25.0' && item.result < '30.0' ? '비만' : item.result >= '30.0' ? '고도비만' : ''
                                          }
                                          color="primary"
                                          size='small'
                                          sx={{
                                            bgcolor: item.result < '18.5' ? 'rgb(189, 186, 26)' : item.result >= '18.5' && item.result < '23.0' ? 'rgb(0, 170, 0)' : item.result >= '23.0' && item.result < '25.0' ? 'rgb(179, 95, 214)' : item.result >= '25.0' && item.result < '30.0' ? 'rgb(255, 85, 85)' : item.result >= '30.0' ? 'rgb(229,36,36)' : '',
                                            fontSize: 12,
                                          }}
                                        />
                                      </Box>
                                    </Stack>
                                    : <Stack direction={'row'} alignItems={'center'}>
                                      <Typography sx={resultTitle}>{item.inspection}</Typography>
                                      <Box sx={{ ml: 'auto' }}>
                                        <Chip label={item.resultCase === 'B' ? (
                                          item.resultRatio < 33 ? '낮음' : item.resultRatio >= 33 && item.resultRatio <= 66 ? '정상' : item.resultRatio > 66 ? '높음' : ''
                                        ) : (
                                          item.resultRatio < 50 ? '비정상' : '정상'
                                        )} color="primary" size='small' sx={{
                                          bgcolor: item.resultCase === 'B' ? (
                                            item.resultRatio < 33 ? 'rgb(189,186,26)' : item.resultRatio >= 33 && item.resultRatio <= 66 ? '#2bbe43' : item.resultRatio > 66 ? '#ff6f6f' : ''
                                          ) : (
                                            item.resultRatio < 50 ? '#ff6f6f' : '#2bbe43'
                                          ), fontSize: 12,
                                        }} />
                                      </Box>
                                    </Stack>
                                }

                                {
                                  item.resultCase === 'B' ? (

                                    item.inspection === '비만도(BMI)'
                                      ? <Box sx={{ mt: 1 }}>
                                        <Box sx={{ width: '100%', textAlign: 'center' }}>
                                          <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                            <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {Number(item.result).toFixed(2)}</Typography>
                                            <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                          </Box>
                                        </Box>

                                        <Box sx={{ width: '100%', textAlign: 'center', display: 'flex', height: 10, alignItems: 'center', justifyContent: 'center', mt: -1.5, mb: 1 }}>
                                          <Box sx={{ backgroundColor: 'rgb(189, 186, 26)', width: '20%', fontSize: '12px', color: '#fff' }}>저체중</Box>
                                          <Box sx={{ backgroundColor: 'rgb(0, 170, 0)', width: '20%', fontSize: '12px', color: '#fff' }}>정상</Box>
                                          <Box sx={{ backgroundColor: 'rgb(179, 95, 214)', width: '20%', fontSize: '12px', color: '#fff' }}>과체중</Box>
                                          <Box sx={{ backgroundColor: 'rgb(255, 85, 85)', width: '20%', fontSize: '12px', color: '#fff' }}>비만</Box>
                                          <Box sx={{ backgroundColor: 'rgb(229,36,36)', width: '20%', fontSize: '12px', color: '#fff' }}>고도비만</Box>
                                        </Box>
                                      </Box>
                                      :
                                      <Box sx={{ mt: 1 }}>
                                        <Box sx={{ width: '100%', textAlign: 'center' }}>
                                          <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                            <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                            <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                          </Box>
                                        </Box>

                                        <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                          <Grid item xs={4} bgcolor={'rgb(189,186,26)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                            낮음
                                          </Grid>
                                          <Grid item xs={4} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                            정상
                                          </Grid>
                                          <Grid item xs={4} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                            높음
                                          </Grid>
                                        </Grid>
                                        <Box>
                                        </Box>
                                      </Box>
                                  ) : (
                                    <Box sx={{ mt: 1 }}>
                                      <Box sx={{ width: '100%', textAlign: 'center' }}>
                                        <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                          <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                          <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                        </Box>
                                      </Box>

                                      <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                        <Grid item xs={6} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                          비정상
                                        </Grid>
                                        <Grid item xs={6} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                          정상
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  )
                                }
                              </Card>
                            )
                          ))}
                        </Box>
                      ))
                    )}
                  </React.Fragment>
                )}

              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', m: 1 }}>
              <Button autoFocus onClick={handleClose} sx={{ bgcolor: '#0d6703', color: '#fff', width: 200, borderRadius: 6, '&:hover': { bgcolor: '#074300' } }}>
                확인
              </Button>
            </DialogActions>
          </BootstrapDialog>



          {/* <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            <Box
              sx={{ pb: 2, bgcolor: '#f9f9f9', width: '50%' }}
              role="presentation"
              onKeyDown={toggleDrawer(props.anchor, false)}
            >
              <Stack direction={'row'} justifyContent={'center'} mb={1} p={2} sx={{ position: 'fixed', width: '100%', bgcolor: '#fff', zIndex: 1, boxSizing: 'border-box', borderBottom: '1px solid #ccc' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', }}>{props.componentName.replaceAll('<br />', ' / ',).replaceAll("<span style='letter-spacing:0'>", '').replaceAll('</span>', '')}</Typography>

                <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', mr: 1, color: '#777' }} onClick={toggleDrawer(props.anchor, false)}>X</Typography>
              </Stack>

              {props.componentName === '종합소견' ? (
                <Box sx={{ p: 2, pt: 10, bgcolor: '#f9f9f9' }}>
                  {props.resultItemData && props.resultItemData.map((item: any) => (
                    <Card sx={resultBox}>
                      <Typography sx={resultTotal}>{item}</Typography>
                    </Card>
                  ))}
                </Box>
              ) : (
                <React.Fragment>
                  <Box sx={{ bgcolor: '#fff', p: 1, textAlign: 'right', pr: 2, pt: 10 }}>
                    <Typography sx={{ fontSize: 14, }}>검진항목 <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 700 }}>{props.resultItemData.length}</Typography>개</Typography>
                  </Box>

                  {categoryB.length <= 0 ? (
                    <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ my: 10, }}>
                      <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
                      <Typography sx={{ fontSize: 16, color: '#888' }} >
                        {props.componentName.replaceAll('<br />', '/').replaceAll("<span style='letter-spacing:0'>", '').replaceAll("</span>", '')} 정보가 없습니다.
                      </Typography>
                    </Stack>
                  ) : (
                    categoryB && categoryB.map((itemKey: any) => (
                      <Box sx={{ p: 2, bgcolor: '#f9f9f9' }}>
                        <Typography sx={mainTitle}></Typography>
                        <Divider sx={titleDivider} >{itemKey}</Divider>

                        {props.resultItemData.filter((v: any) => v.categoryB === itemKey).map((item: any, index: any) => (
                          item.resultCase === 'A' ? (
                            <Card sx={resultBox}>
                              <Typography sx={resultTitle}>{item.inspection}</Typography>
                              <Divider orientation="vertical" flexItem sx={divider} />
                              <Typography sx={result}>{util.strNull(item.result).trim() !== '' ? item.result : '-'} <Typography component={'span'} sx={resultUnit}>{item.unit}</Typography></Typography>
                            </Card>
                          ) : (
                            <Card sx={resultChartBox}>
                              <Stack direction={'row'} alignItems={'center'}>
                                <Typography sx={resultTitle}>{item.inspection}</Typography>
                                <Box sx={{ ml: 'auto' }}>
                                  <Chip label={item.resultCase === 'B' ? (
                                    item.resultRatio < 33 ? '낮음' : item.resultRatio >= 33 && item.resultRatio <= 66 ? '정상' : item.resultRatio > 66 ? '높음' : ''
                                  ) : (
                                    item.resultRatio < 50 ? '비정상' : '정상'
                                  )} color="primary" size='small' sx={{
                                    bgcolor: item.resultCase === 'B' ? (
                                      item.resultRatio < 33 ? 'rgb(189,186,26)' : item.resultRatio >= 33 && item.resultRatio <= 66 ? '#2bbe43' : item.resultRatio > 66 ? '#ff6f6f' : ''
                                    ) : (
                                      item.resultRatio < 50 ? '#ff6f6f' : '#2bbe43'
                                    ), fontSize: 12,
                                  }} />
                                </Box>
                              </Stack>

                              {item.resultCase === 'B' ? (

                                <Box sx={{ mt: 1 }}>
                                  <Box sx={{ width: '100%', textAlign: 'center' }}>
                                    <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                      <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                      <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                    </Box>
                                  </Box>

                                  <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                    <Grid item xs={4} bgcolor={'rgb(189,186,26)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                      낮음
                                    </Grid>
                                    <Grid item xs={4} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                      정상
                                    </Grid>
                                    <Grid item xs={4} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                      높음
                                    </Grid>
                                  </Grid>

                                  <Box>

                                  </Box>
                                </Box>
                              ) : (

                                <Box sx={{ mt: 1 }}>
                                  <Box sx={{ width: '100%', textAlign: 'center' }}>
                                    <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                      <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                      <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                    </Box>
                                  </Box>

                                  <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                    <Grid item xs={6} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                      비정상
                                    </Grid>
                                    <Grid item xs={6} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                      정상
                                    </Grid>
                                  </Grid>
                                </Box>
                              )}
                            </Card>
                          )
                        ))}
                      </Box>
                    ))
                  )}
                </React.Fragment>
              )}

            </Box>
          </SwipeableDrawer> */}
        </React.Fragment>
      ))
      }
    </React.Fragment >
  );
}

const toolTip = {}

const mainTitle = {
  fontSize: 16,
  fontWeight: 700,
  mb: 1
}

const titleDivider = {
  mt: 1, mb: 2, fontWeight: 700,
  '& span': { bgcolor: '#ddd', borderRadius: 4, py: .5, px: 2, fontSize: 14 }
}

const resultBox = {
  p: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', mb: 2
}

const resultChartBox = {
  p: '16px 35px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', mb: 2
}

const resultTitle = {
  fontSize: 14,
  flex: 1,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const result = {
  fontSize: 14,
  fontWeight: 700,
  flex: 1,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const resultTotal = {
  fontSize: 14,
}


const resultUnit = {
  fontSize: 12,
  ml: .5
}

const divider = {
  mx: 1,
}

const resultIconBtn = {
  bgcolor: '#f9f9f9', p: 1, borderRadius: 4, textAlign: 'center', width: '80%', height: 200,
  '&:hover': { bgcolor: '#eee' },
  '& p': { fontSize: 16, color: '#555', },
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '25%',
  marginBottom: '20px !important'
});

const bmiStep = {
  p: '0 !important',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
}

export default HealthResultItem;